import { ViesValidationResult, buildCif, sanitizeViesField } from '../domain/ViesValidatorDomain'

export class ViesValidatorApplication {
  constructor(
    private readonly infra: { validate(cif: string): Promise<ViesValidationResult> }
  ) {}

  async validateVies(cif: string, country: string): Promise<ViesValidationResult> {
    const fullCif = buildCif(cif, country)
    const result = await this.infra.validate(fullCif)
    return {
      ...result,
      name: sanitizeViesField(result.name),
      address: sanitizeViesField(result.address)
    }
  }
}
